import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { RootState } from 'app';
import { DEVICES } from 'utils';

export const initialDevice = createAsyncThunk(
  'app/initialDevice',
  async (body: DEVICES, { rejectWithValue }) => {
    try {
      return body;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface AppDeviceState {
  device: DEVICES;
  isFirstLoad: boolean;
  isSpecificBrowser: boolean;
}

const initialState: AppDeviceState = {
  device: DEVICES.DESKTOP,
  isFirstLoad: true,
  isSpecificBrowser: false,
};

const appDeviceSlice = createSlice({
  name: 'appDevice',
  initialState,
  reducers: {
    setIsSpecificBrowser(state) {
      state.isSpecificBrowser = true;
    },
  },
  extraReducers: builder => {
    builder.addCase(initialDevice.fulfilled, (state, { payload }) => {
      state.device = payload as DEVICES;
      state.isFirstLoad = false;

      if (payload == DEVICES.DESKTOP) {
        state.isSpecificBrowser = false;
      }
    });
  },
});

const { actions, reducer: appDeviceReducer } = appDeviceSlice;

export default appDeviceReducer;

export const { setIsSpecificBrowser } = actions;

export const selectAppDevice = (state: RootState): AppDeviceState =>
  state.appDevice as AppDeviceState;
